"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactTabs = require("react-tabs");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _excluded = ["activeIndex", "className", "children", "onTabClick"],
  _excluded2 = ["trigger", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The Tabs component provides a convenient way to separate content into different panes.
 * Each pane is viewable one at a time, activated onClick of a corresponding tab control.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/reactjs/react-tabs">ReactTabs</a>.
 */
var Tabs = function Tabs(_ref) {
  var activeIndex = _ref.activeIndex,
    className = _ref.className,
    children = _ref.children,
    onTabClick = _ref.onTabClick,
    attributes = _objectWithoutPropertiesLoose(_ref, _excluded);
  var tabsRef = _react.default.useRef(null);
  var _React$useState = _react.default.useState(null),
    stateActive = _React$useState[0],
    setActive = _React$useState[1];
  _react.default.useEffect(function () {
    return setActive(activeIndex);
  }, [activeIndex]);
  var list = [];
  if (Array.isArray(children)) {
    list = children;
  } else if ( /*#__PURE__*/_react.default.isValidElement(children)) {
    list.push(children);
  }
  /* In case of using Array.map to render Tabs (Array.flat(); unsupported by IE) */
  if (list && list.length) list = list.reduce(function (acc, val) {
    return acc.concat(val);
  }, []);
  var handleTabClick = function handleTabClick(tabIndex) {
    setActive(tabIndex);
    if (onTabClick && typeof onTabClick === 'function') {
      onTabClick(tabIndex);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactTabs.Tabs, _extends({
    ref: tabsRef,
    className: "uk-tabs " + className,
    selectedIndex: stateActive || 0,
    onSelect: function onSelect(tabIndex) {
      return handleTabClick(tabIndex);
    },
    disabledTabClassName: "uk-tabs__tab--disabled",
    selectedTabClassName: "uk-tabs__tab--selected",
    selectedTabPanelClassName: "uk-tabs__tab-panel--selected"
  }, attributes), /*#__PURE__*/_react.default.createElement(_reactTabs.TabList, {
    className: "uk-tabs__tab-list",
    role: "tablist"
  }, list.map(function (child, i) {
    if (child.props && child.props.trigger) {
      var _child$props = child.props,
        disabled = _child$props.disabled,
        trigger = _child$props.trigger,
        icon = _child$props.icon,
        childClassName = _child$props.className;
      return /*#__PURE__*/_react.default.createElement(_reactTabs.Tab, {
        key: i,
        className: (0, _clsx.default)('uk-tabs__tab', childClassName),
        disabled: disabled
      }, icon && icon.length > 0 && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: icon
      }), /*#__PURE__*/_react.default.createElement("span", null, trigger));
    }
    return null;
  })), list.map(function (child, i) {
    if (child.props && !child.props.trigger) {
      return child;
    }
    return null;
  }), list.map(function (child, i) {
    if (child.props && child.props.trigger) {
      var _child$props2 = child.props,
        trigger = _child$props2.trigger,
        _className = _child$props2.className,
        rest = _objectWithoutPropertiesLoose(_child$props2, _excluded2);
      return /*#__PURE__*/_react.default.createElement(_reactTabs.TabPanel, _extends({
        key: i,
        className: "uk-tabs__tab-panel " + (_className || '')
      }, rest));
    }
    return null;
  }));
};
Tabs.propTypes = {
  /**
   * Set to open one of the Tabs (0-based index)
   */
  activeIndex: _propTypes.default.number,
  /**
   * Callback function onTabClick
   */
  onTabClick: _propTypes.default.func
};
var _default = exports.default = Tabs;